var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-shell",attrs:{"id":"app"}},[_c('Header'),_c('main',{staticClass:"app-main"},[_c('router-view')],1),_c('Footer'),_c('GoTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }